import { Table } from '@mantine/core';
import { FC } from 'react';

import { formatCountFr } from '../../../lib/utils/gp-surfaces-format';

import type { GpSurfacesSamplingMetricsValues } from './gp-surfaces-sampling-metrics-tables';
import { SamplerCoverageMetricText } from './sampler-coverage-metric-text';

type SamplerCoverageMetricsCellsProps = {
  metrics: GpSurfacesSamplingMetricsValues;
  emphasizeTotals?: boolean;
};

export const SamplerCoverageMetricsCells: FC<SamplerCoverageMetricsCellsProps> = ({
  metrics,
  emphasizeTotals,
}) => (
  <>
    <Table.Td ta="right">
      <SamplerCoverageMetricText value={formatCountFr(metrics.carbon_points)} />
    </Table.Td>
    <Table.Td ta="right">
      <SamplerCoverageMetricText value={formatCountFr(metrics.granulo_points)} />
    </Table.Td>
    <Table.Td ta="right">
      <SamplerCoverageMetricText
        fw={emphasizeTotals ? 700 : undefined}
        value={formatCountFr(metrics.total_sampling_points)}
      />
    </Table.Td>
    <Table.Td ta="right">
      <SamplerCoverageMetricText value={formatCountFr(metrics.analysis_count)} />
    </Table.Td>
    <Table.Td ta="right">
      <SamplerCoverageMetricText
        value={formatCountFr(metrics.granulo_analysis_count)}
      />
    </Table.Td>
    <Table.Td ta="right">
      <SamplerCoverageMetricText
        fw={emphasizeTotals ? 700 : undefined}
        value={formatCountFr(metrics.total_analysis_count)}
      />
    </Table.Td>
  </>
);
